import type { TemplateDataspace, Graph } from "@lr-notitia/notitia-operator/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const templateDataspaces = (graph: Ref<Graph>) =>
	computed<TemplateDataspace[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "dataspace" && node.layer === "template"
			) as TemplateDataspace[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology })
				.toLocaleLowerCase()
				.localeCompare(symbolsStore.term({ id: b.refersTo, terminology: b.terminology }).toLocaleLowerCase())
		);
	});

export function templateDataspace(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
	};
}

function byId(id: string, graph: Ref<Graph>): TemplateDataspace | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.layer === "template" && hit.type === "dataspace" ? (hit as TemplateDataspace) : undefined;
}
